@if (hasHinweise) {
    <pf-section name="hints" [title]="'sendmail.prepare.step.hints' | i18next">
        <div class="row ba-form-row">

            <!-- Hinweise zu Anliegen -->
            @if (hasSubanliegenHinweis || hasSubanliegenLink) {
                <div class="col">
                    @if (hasSubanliegenHinweis) {
                        <div [innerHTML]="subanliegen!.hinweis"></div>
                    }
                    @if (hasSubanliegenLink) {
                        <p class="mb-0">
                            <pf-link-out
                                    name="subanliegen-infos"
                                    [linkText]="subanliegen!.linkText"
                                    [link]="subanliegen!.link">
                            </pf-link-out>
                        </p>
                    }
                </div>

                <!-- Hinweise zu ZKT-Dienststellen ohne Anliegen -->
            } @else if (jobcenterZKTNotActive) {
                <pf-hinweisbox
                        [boxType]="HinweisboxTypeEnum.WARNING"
                        boxId="zkt">
                    {{ 'sendmail.prepare.step.jc-provider' | i18next }}
                </pf-hinweisbox>

                <!-- Hinweise zu GE-Dienststellen ohne Anliegen -->
            } @else if (jobcenterGeNotActive) {
                <pf-hinweisbox
                        [boxType]="HinweisboxTypeEnum.WARNING"
                        boxId="ge">
                    {{ 'sendmail.prepare.step.jc-unreachable' | i18next }}
                </pf-hinweisbox>
            }
        </div>
    </pf-section>
}